export const NUMBER_TO_WORDS = {
  "00": [{ abbr: "ss", word: "sauce सॉस" }],
  "01": [{ abbr: "st", word: "stick स्टिक" }],
  "02": [{ abbr: "sn", word: "sun सूरज" }],
  "03": [{ abbr: "sm", word: "sam सैम" }],
  "04": [{ abbr: "sr", word: "sir सर" }],
  "05": [{ abbr: "sl", word: "sallu सलमान" }],
  "06": [{ abbr: "sg", word: "sage साधु" }],
  "07": [{ abbr: "sk", word: "sky आसमान" }],
  "08": [{ abbr: "sf", word: "saif सैफ" }],
  "09": [{ abbr: "sp", word: "soap साबुन" }],
  10: [{ abbr: "st", word: "suit सूट" }],
  11: [{ abbr: "dd", word: "dad पापा" }],
  12: [{ abbr: "dn", word: "den गुफा" }],
  13: [{ abbr: "dm", word: "dam बांध" }],
  14: [{ abbr: "dr", word: "deer हिरण" }],
  15: [{ abbr: "dl", word: "doll गुड़िया" }],
  16: [{ abbr: "dg", word: "dog कुत्ता" }],
  17: [{ abbr: "dk", word: "dake डेक" }],
  18: [
    { abbr: "tv", word: "TV टीवी" },
    { abbr: "tf", word: "toffee टॉफ़ी" },
  ],
  19: [{ abbr: "tp", word: "tap नल" }],
  20: [{ abbr: "ns", word: "nose नाक" }],
  21: [{ abbr: "nt", word: "net जाल" }],
  22: [{ abbr: "nn", word: "nana नाना" }],
  23: [{ abbr: "nm", word: "neem नीम" }],
  24: [{ abbr: "nr", word: "nare नारे" }],
  25: [{ abbr: "nl", word: "nail कील" }],
  26: [{ abbr: "ng", word: "nag नाग" }],
  27: [{ abbr: "nk", word: "nokia नोकिया" }],
  28: [{ abbr: "nv", word: "navy नौसेना" }],
  29: [{ abbr: "np", word: "no problem कोई समस्या नहीं" }],
  30: [{ abbr: "ms", word: "mess गड़बड़" }],
  31: [{ abbr: "mt", word: "mat चटाई" }],
  32: [{ abbr: "mn", word: "moon चाँद" }],
  33: [
    { abbr: "mm", word: "maam मैम" },
    { abbr: "mm", word: "mama मामा" },
  ],
  34: [{ abbr: "mr", word: "amir अमीर" }],
  35: [{ abbr: "ml", word: "mail मेल" }],
  36: [
    { abbr: "mj", word: "michael jackson माइकल जैक्सन" },
    { abbr: "mj", word: "muj मुझ" },
  ],
  37: [{ abbr: "mk", word: "mike माइक" }],
  38: [{ abbr: "mf", word: "mf hussain एम एफ हुसैन" }],
  39: [{ abbr: "mp", word: "map नक्शा" }],
  40: [{ abbr: "rs", word: "rose गुलाब" }],
  41: [{ abbr: "rt", word: "rat चूहा" }],
  42: [{ abbr: "rn", word: "rain बारिश" }],
  43: [{ abbr: "rm", word: "ram राम" }],
  44: [{ abbr: "rr", word: "rare दुर्लभ" }],
  45: [{ abbr: "rl", word: "rail रेल" }],
  46: [{ abbr: "rj", word: "raja राजा" }],
  47: [{ abbr: "rk", word: "rack रैक" }],
  48: [{ abbr: "rf", word: "rifle राइफल" }],
  49: [{ abbr: "rp", word: "rope रस्सी" }],
  50: [{ abbr: "ls", word: "lassi लस्सी" }],
  51: [
    { abbr: "lt", word: "late लेट" },
    { abbr: "lt", word: "lata लता" },
  ],
  52: [{ abbr: "ln", word: "lion सिंह" }],
  53: [{ abbr: "lm", word: "lime नींबू" }],
  54: [{ abbr: "lr", word: "lara लारा" }],
  55: [{ abbr: "ll", word: "lalu लालू" }],
  56: [{ abbr: "lg", word: "lg एलजी" }],
  57: [{ abbr: "lk", word: "lake झील" }],
  58: [
    { abbr: "lv", word: "live लाइव" },
    { abbr: "lf", word: "life जीवन" },
  ],
  59: [{ abbr: "lb", word: "lab प्रयोगशाला" }],
  60: [{ abbr: "js", word: "jassie जैसी" }],
  61: [{ abbr: "jt", word: "jet जेट" }],
  62: [{ abbr: "gn", word: "gun बंदूक" }],
  63: [{ abbr: "jm", word: "jam जाम" }],
  64: [{ abbr: "jr", word: "jar जार" }],
  65: [{ abbr: "jl", word: "jail जेल" }],
  66: [{ abbr: "jg", word: "jug जग" }],
  67: [{ abbr: "jk", word: "jackie जैकी" }],
  68: [{ abbr: "gf", word: "gf गर्लफ्रेंड" }],
  69: [{ abbr: "jp", word: "jeep जीप" }],
  70: [{ abbr: "ks", word: "kiss चुंबन" }],
  71: [{ abbr: "kt", word: "kite पतंग" }],
  72: [{ abbr: "kn", word: "kaan कान" }],
  73: [{ abbr: "km", word: "kima कीमा" }],
  74: [{ abbr: "kr", word: "kar कार" }],
  75: [{ abbr: "kl", word: "kalia कालिया" }],
  76: [{ abbr: "kj", word: "kaju काजू" }],
  77: [{ abbr: "kk", word: "kaka काका" }],
  78: [{ abbr: "kf", word: "kaif कैफ" }],
  79: [{ abbr: "kp", word: "kap कैप" }],
  80: [{ abbr: "fs", word: "fuse फ्यूज" }],
  81: [{ abbr: "ft", word: "foot पैर" }],
  82: [{ abbr: "vn", word: "van वैन" }],
  83: [{ abbr: "fm", word: "fm एफ एम" }],
  84: [{ abbr: "fr", word: "fire आग" }],
  85: [{ abbr: "fl", word: "fail फेल" }],
  86: [{ abbr: "fj", word: "fauji फौजी" }],
  87: [{ abbr: "fk", word: "fork कांटा" }],
  88: [
    { abbr: "ff", word: "fufa फूफा" },
    { abbr: "ff", word: "fifa फीफा" },
  ],
  89: [{ abbr: "fp", word: "fountain pepsi फाउंटेन पेप्सी" }],
  90: [{ abbr: "bs", word: "bus बस" }],
  91: [{ abbr: "bd", word: "bed बिस्तर" }],
  92: [{ abbr: "pn", word: "pen कलम" }],
  93: [{ abbr: "pm", word: "pm प्रधानमंत्री" }],
  94: [{ abbr: "br", word: "bar बार" }],
  95: [{ abbr: "bl", word: "bail जमानत" }],
  96: [{ abbr: "bg", word: "bag बैग" }],
  97: [{ abbr: "bk", word: "bike बाइक" }],
  98: [{ abbr: "bf", word: "bf बॉयफ्रेंड" }],
  99: [{ abbr: "bp", word: "baby बच्चा" }],
};

export const DIGIT_TO_LETTER = {
  0: ["S"],
  1: ["D", "T"],
  2: ["N"],
  3: ["M"],
  4: ["R"],
  5: ["L"],
  6: ["G", "J"],
  7: ["K"],
  8: ["F", "V"],
  9: ["B", "P"],
};
